document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-generator').forEach(initGenerator);
});

function initGenerator(root) {
  const steps = root.querySelectorAll('.gen-step');

  let selectedPrompts = [];
  let selectedMoodLabel = '';
  let userName = '';

  const fallbackBackground = root.dataset.fallbackPhoto || '';
  const fallbackMascot = root.dataset.fallbackMascot || '';

  const backgroundPool = (root.dataset.inviteBackgrounds || '')
    .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  const mascotPool = (root.dataset.inviteMascots || '')
    .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  const doodlePool = (root.dataset.inviteDoodles || '')
    .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

  const sharePrefix = root.dataset.sharePrefix || '';
  const shareLink = root.dataset.shareLink || '';

  const frameSequence = root.querySelector('[data-gen-frame-sequence]');
  let frameInterval = null;

  function showStep(name) {
    steps.forEach(function (s) {
      s.dataset.active = (s.dataset.step === name) ? 'true' : 'false';
    });
    root.dataset.step = name;
  }

  function splitPromptLine(line) {
    const parts = line.split(/\s[-–—]\s/);
    return {
      heading: (parts[0] || '').trim(),
      description: (parts[1] || parts[0] || '').trim()
    };
  }

  function pickPrompt() {
    if (!selectedPrompts.length) {
      return { heading: '', description: "go outside and do something fun together." };
    }
    const line = selectedPrompts[Math.floor(Math.random() * selectedPrompts.length)];
    return splitPromptLine(line);
  }

  function pickFromPool(pool, fallback) {
    if (pool.length) {
      return pool[Math.floor(Math.random() * pool.length)];
    }
    return fallback;
  }

  function pickBackground() { return pickFromPool(backgroundPool, fallbackBackground); }
  function pickMascot() { return pickFromPool(mascotPool, fallbackMascot); }

  function startFrameLoop() {
    if (!frameSequence) return;
    const frames = frameSequence.querySelectorAll('[data-gen-frame]');
    if (!frames.length) return;
    const speed = parseInt(frameSequence.dataset.frameSpeed, 10) || 300;
    let i = 0;
    frames.forEach(function (f, idx) {
      f.dataset.frameActive = idx === 0 ? 'true' : 'false';
    });
    frameInterval = setInterval(function () {
      frames[i].dataset.frameActive = 'false';
      i = (i + 1) % frames.length;
      frames[i].dataset.frameActive = 'true';
    }, speed);
  }

  function stopFrameLoop() {
    if (frameInterval) {
      clearInterval(frameInterval);
      frameInterval = null;
    }
  }

  root.querySelectorAll('.gen-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectedMoodLabel = btn.dataset.label || btn.textContent.trim();
      selectedPrompts = (btn.dataset.prompts || '')
        .split('\n')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      showStep('loading');
      startFrameLoop();
    });
  });

  function submitToSheet(name, email, phone) {
    if (!email) return Promise.resolve();
    return fetch('https://script.google.com/macros/s/AKfycbxuaHxtAM_YZIbfR0LuFwcf3LafZzFvJClILYZcI87Vq3L1wglWNH-4KHUpgORXnhEE/exec', {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ name: name, email: email, phone: phone })
    }).catch(function () {});
  }

      const emailForm = root.querySelector('[data-gen-email-form]');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const nameInput = root.querySelector('[data-gen-name]');
      userName = nameInput ? nameInput.value.trim() : '';

      const emailInput = root.querySelector('[data-gen-email]');
      const userEmail = emailInput ? emailInput.value.trim() : '';

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(userEmail)) {
        alert('Please enter a valid email address.');
        return;
      }

      const phoneInput = root.querySelector('[data-gen-phone]');
      const userPhone = phoneInput ? phoneInput.value.trim() : '';

      if (!/^\d{10}$/.test(userPhone)) {
        alert('Please enter a valid 10-digit phone number.');
        return;
      }

      const formattedPhone = '+91' + userPhone;

      revealPrompt();
      submitToSheet(userName, userEmail, formattedPhone);
    });
  }

  let currentShareText = '';
  let pregeneratedFile = null;

  function renderDoodles() {
    const layer = root.querySelector('[data-gen-doodle-layer]');
    if (!layer) return;
    layer.innerHTML = '';
    if (!doodlePool.length) return;

    const shuffled = doodlePool.slice().sort(function () {
      return Math.random() - 0.5;
    });
    const chosen = shuffled.slice(0, 2);

    const positions = [
      { top: '1%', left: '3%' },
      { top: '1%', right: '3%' }
    ];

    chosen.forEach(function (src, i) {
      const pos = positions[i];
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.crossOrigin = 'anonymous';
      img.className = 'gen-doodle-item';
      const rot = (Math.random() * 16 - 8).toFixed(1);
      if (pos.left) img.style.left = pos.left;
      if (pos.right) img.style.right = pos.right;
      img.style.top = pos.top;
      img.style.transform = 'rotate(' + rot + 'deg)';
      layer.appendChild(img);
    });
  }

  function autoFitPromptText(el) {
    if (!el) return;
    let size = parseFloat(window.getComputedStyle(el).fontSize) || 10;
    let lineHeight = 1.5;
    el.style.fontSize = size + 'px';
    el.style.lineHeight = lineHeight;
    let guard = 0;
    while (el.scrollHeight > el.clientHeight && size > 8 && guard < 20) {
      size -= 0.5;
      lineHeight = Math.max(1.15, lineHeight - 0.02);
      el.style.fontSize = size + 'px';
      el.style.lineHeight = lineHeight;
      guard++;
    }
  }

  function ensureFontsLoaded(card) {
    const specs = new Set();
    const els = card.querySelectorAll('*');
    els.forEach(function (el) {
      const cs = window.getComputedStyle(el);
      if (!cs || !cs.fontFamily) return;
      const weight = cs.fontWeight || '400';
      const size = cs.fontSize || '16px';
      specs.add(weight + ' ' + size + ' ' + cs.fontFamily);
    });

    const loadPromises = Array.from(specs).map(function (spec) {
      try {
        return document.fonts.load(spec).catch(function () {});
      } catch (e) {
        return Promise.resolve();
      }
    });

    const readyPromise = (document.fonts && document.fonts.ready)
      ? document.fonts.ready.catch(function () {})
      : Promise.resolve();

    return Promise.all(loadPromises).then(function () { return readyPromise; });
  }

  function waitForImages(card) {
    const imgs = Array.from(card.querySelectorAll('img'));
    return Promise.all(imgs.map(function (img) {
      if (!img.src) return Promise.resolve();
      if (img.complete && img.naturalWidth !== 0) {
        return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
      }
      return new Promise(function (resolve) {
        img.addEventListener('load', function () {
          if (img.decode) {
            img.decode().then(resolve).catch(resolve);
          } else {
            resolve();
          }
        }, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    }));
  }

  function captureCard() {
    const card = root.querySelector('[data-gen-poster-card]');
    if (!card || typeof html2canvas === 'undefined') return Promise.resolve(null);

    const settle = new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(resolve);
      });
    });

    return Promise.all([
      ensureFontsLoaded(card),
      waitForImages(card),
      settle
    ]).then(function () {
      return html2canvas(card, {
        backgroundColor: null,
        scale: 2,
        useCORS: true,
        onclone: function (clonedDoc, clonedCard) {
          const target = clonedCard || clonedDoc.querySelector('[data-gen-poster-card]');
          return clonedDoc.fonts.ready.then(function () {
            return new Promise(function (resolve) {
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  if (target) {
                    const h = target.scrollHeight;
                    target.style.height = h + 'px';
                  }
                  resolve();
                });
              });
            });
          });
        }
      });
    });
  }

  function revealPrompt() {
    stopFrameLoop();
    const picked = pickPrompt();
    const heading = picked.heading;
    const description = picked.description;
    const background = pickBackground();
    const mascot = pickMascot();

    const titleNameEl = root.querySelector('[data-gen-poster-title-name]');
    const moodEl = root.querySelector('[data-gen-poster-mood]');
    const activityHeadingEl = root.querySelector('[data-gen-poster-activity-heading]');
    const bgEl = root.querySelector('[data-gen-poster-bg]');
    const mascotEl = root.querySelector('[data-gen-poster-mascot]');
    const promptEl = root.querySelector('[data-gen-poster-prompt]');

    if (titleNameEl) {
      titleNameEl.textContent = (userName ? userName : 'your') + "'s";
    }

    if (moodEl) {
      moodEl.textContent = selectedMoodLabel || '';
    }

    if (activityHeadingEl) {
      activityHeadingEl.textContent = heading || '';
    }

    if (bgEl) {
      if (background) { bgEl.src = background; bgEl.style.display = ''; }
      else { bgEl.removeAttribute('src'); bgEl.style.display = 'none'; }
    }
    if (mascotEl) {
      if (mascot) { mascotEl.src = mascot; mascotEl.style.display = ''; }
      else { mascotEl.removeAttribute('src'); mascotEl.style.display = 'none'; }
    }

    if (promptEl) {
      promptEl.textContent = description;
    }

    renderDoodles();

    const parts = [];
    parts.push('hii!! here\'s today\'s playdate: ' + description + ' See the invite for more details ;)');
parts.push('Oh and I made this using ' + shareLink + ' btw');
    currentShareText = parts.join('\n');

    const waLink = root.querySelector('[data-gen-share-wa]');
    if (waLink) {
      waLink.href = 'https://wa.me/?text=' + encodeURIComponent(currentShareText);
    }

    showStep('invite');

    requestAnimationFrame(function () {
      if (promptEl) {
        autoFitPromptText(promptEl);
      }
    });

    // Pre-generate the shareable image now, in the background, while the
    // person is looking at their invite — NOT inside the WhatsApp click
    // handler. This means by the time they actually tap share, the file
    // already exists and navigator.share() can fire synchronously, inside
    // the real tap gesture, instead of after an async capture delay that
    // causes iOS to silently block the share/redirect.
    pregeneratedFile = null;
    captureCard().then(function (canvas) {
      if (!canvas) return;
      canvas.toBlob(function (blob) {
        if (!blob) return;
        pregeneratedFile = new File([blob], 'playdate-invite.png', { type: 'image/png' });
      }, 'image/png');
    });
  }

  function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = filename;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 1000);
  }

  const waLink = root.querySelector('[data-gen-share-wa]');
  if (waLink) {
    waLink.addEventListener('click', function (e) {
      e.preventDefault();

      if (pregeneratedFile && navigator.canShare && navigator.canShare({ files: [pregeneratedFile] })) {
        navigator.share({ files: [pregeneratedFile], text: currentShareText }).catch(function () {
          window.open(waLink.href, '_blank');
        });
      } else {
        window.open(waLink.href, '_blank');
      }
    });
  }

  const igBtn = root.querySelector('[data-gen-share-ig]');
  if (igBtn) {
    igBtn.addEventListener('click', function () {
      function copyFallback() {
        navigator.clipboard.writeText(currentShareText).then(function () {
          igBtn.setAttribute('aria-label', 'Copied — paste into Instagram');
          setTimeout(function () {
            igBtn.setAttribute('aria-label', 'Share on Instagram');
          }, 2200);
        });
      }

      if (pregeneratedFile && navigator.canShare && navigator.canShare({ files: [pregeneratedFile] })) {
        navigator.share({ files: [pregeneratedFile], text: currentShareText }).catch(function () {
          copyFallback();
        });
      } else {
        copyFallback();
      }
    });
  }

  const downloadBtn = root.querySelector('[data-gen-download]');
  if (downloadBtn) {
    downloadBtn.addEventListener('click', function () {
      if (pregeneratedFile) {
        if (navigator.canShare && navigator.canShare({ files: [pregeneratedFile] })) {
          navigator.share({ files: [pregeneratedFile] }).catch(function () {
            pregeneratedFile.arrayBuffer().then(function (buf) {
              downloadBlob(new Blob([buf], { type: 'image/png' }), 'my-playdate-invite.png');
            });
          });
        } else {
          pregeneratedFile.arrayBuffer().then(function (buf) {
            downloadBlob(new Blob([buf], { type: 'image/png' }), 'my-playdate-invite.png');
          });
        }
        return;
      }

      downloadBtn.disabled = true;
      downloadBtn.dataset.loading = 'true';

      captureCard().then(function (canvas) {
        if (!canvas) return;

        canvas.toBlob(function (blob) {
          if (!blob) return;

          const file = new File([blob], 'my-playdate-invite.png', { type: 'image/png' });

          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({ files: [file] }).catch(function () {
              downloadBlob(blob, 'my-playdate-invite.png');
            });
          } else {
            downloadBlob(blob, 'my-playdate-invite.png');
          }
        }, 'image/png');
      }).catch(function () {
      }).finally(function () {
        downloadBtn.disabled = false;
        downloadBtn.dataset.loading = 'false';
      });
    });
  }
}